import React from "react";

import "./button.scss";

const Button = ({
  buttonId,
  children,
  disabled,
  title = "",
  type = "",
  width,
  onClick = () => {},
  fontsize,
  padding
}) => {
  return (
    <button
      style={{ fontSize: fontsize, padding: padding }}
      data-testid={buttonId}
      disabled={disabled}
      onClick={onClick}
      className={` buttonComponent ${type}`}
    >
      {title}
    </button>
  );
};

export default Button;
